module.exports = __webpack_public_path__ + "static/media/UrFULogo_U.0bc4820f.jpg";